import React, { useState } from 'react'
import { FaCheckCircle, FaExclamationCircle, FaWhatsapp } from 'react-icons/fa'
import { whatsappBookCallUrl } from '../constants/whatsapp'

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    const fromEnv = process.env.REACT_APP_API_URL?.replace(/\/$/, '');
    const apiBase =
      fromEnv ||
      (process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : '');

    try {
      const response = await fetch(`${apiBase}/api/send-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({ type: 'success', message: 'Message sent successfully! I\'ll get back to you soon.' });
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus({ type: 'error', message: data.error || 'Failed to send message. Please try again.' });
      }
    } catch (error) {
      setStatus({ type: 'error', message: 'Failed to send message. Please make sure the server is running.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div name='work-together' className='w-full bg-white text-gray-900 dark:bg-[#0a192f] dark:text-gray-300 flex justify-center items-center p-4 py-24'>
        <form onSubmit={handleSubmit} className='flex flex-col max-w-[600px] w-full'>
            <div className='pb-8'>
                <p className='text-5xl font-bold inline border-b-4 border-pink-600 text-gray-900 dark:text-gray-300'>Work together</p>
                <p className='text-gray-600 dark:text-[#8892b0] py-4'>
                  Tell me about the workflow or product you want to fix—or email mapajohnedel@gmail.com directly.
                  {whatsappBookCallUrl && (
                    <>
                      {' '}
                      Prefer WhatsApp? Use <span className='text-gray-800 dark:text-[#ccd6f6] font-medium'>Book a call</span> below.
                    </>
                  )}
                </p>
            </div>
            <input 
              className='bg-[#ccd6f6] p-2 text-gray-900 dark:text-gray-900 placeholder-gray-500 dark:placeholder-gray-500' 
              type="text" 
              placeholder='Your Name' 
              name='name' 
              value={formData.name}
              onChange={handleChange}
              required 
            />
            <input 
              className='my-4 p-2 bg-[#ccd6f6] text-gray-900 dark:text-gray-900 placeholder-gray-500 dark:placeholder-gray-500' 
              type="email" 
              placeholder='Your Email' 
              name='email' 
              value={formData.email}
              onChange={handleChange}
              required 
            />
            <textarea 
              className='bg-[#ccd6f6] p-2 text-gray-900 dark:text-gray-900 placeholder-gray-500 dark:placeholder-gray-500' 
              name="message" 
              rows="10" 
              placeholder='Your Message' 
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            {status.message && (
              <div className={`my-4 p-4 rounded-lg border-2 animate-fadeIn ${
                status.type === 'success' 
                  ? 'bg-green-50 border-green-300 text-green-800 dark:bg-green-900/30 dark:border-green-700 dark:text-green-300' 
                  : 'bg-red-50 border-red-300 text-red-800 dark:bg-red-900/30 dark:border-red-700 dark:text-red-300'
              }`}>
                <div className='flex items-center gap-3'>
                  {status.type === 'success' ? (
                    <FaCheckCircle className='text-2xl text-green-600 dark:text-green-400 flex-shrink-0' />
                  ) : (
                    <FaExclamationCircle className='text-2xl text-red-600 dark:text-red-400 flex-shrink-0' />
                  )}
                  <p className='text-sm font-medium'>{status.message}</p>
                </div>
              </div>
            )}
            <div className='flex flex-col sm:flex-row gap-4 items-stretch sm:items-center justify-center w-full mt-8 mb-2'>
              <button 
                type="submit"
                disabled={isSubmitting}
                className='border-2 px-4 py-3 flex items-center justify-center min-h-[48px]
                  text-gray-900 border-gray-900 hover:bg-pink-600 hover:border-pink-600 hover:text-white 
                  dark:text-white dark:border-gray-300 dark:hover:border-pink-600
                  disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 sm:flex-1 sm:max-w-[240px]'>
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
              {whatsappBookCallUrl && (
                <a
                  href={whatsappBookCallUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='group border-2 px-4 py-3 flex items-center justify-center gap-2 min-h-[48px] font-medium
                    border-[#25D366] text-gray-900 bg-[#25D366]/10 hover:bg-[#25D366] hover:border-[#25D366] hover:text-white
                    dark:text-[#ccd6f6] dark:bg-[#25D366]/15 dark:hover:text-white
                    transition-colors duration-200 sm:flex-1 sm:max-w-[240px]'
                >
                  <FaWhatsapp className='text-xl text-[#25D366] group-hover:text-white transition-colors shrink-0' aria-hidden />
                  Book a call
                </a>
              )}
            </div>
        </form>
    </div>
  )
}

export default Contact